'use client';

import React, { useEffect, useRef } from 'react';
import { Slide } from '@/shared/types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { markdownComponents } from './presentationMarkdown';

// Interfaces and types
interface DescriptionPaneProps {
  slide: Slide;
}

// Component definition
const DescriptionPane: React.FC<DescriptionPaneProps> = ({
  slide
}) => {
  const descriptionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
      descriptionRef.current.querySelectorAll('p').forEach(p => {
        p.style.wordBreak = 'break-word';
      });
    }
  }, [slide]);
  return <div ref={descriptionRef} className="slide-boxes box-border mini sm:lg sm:overflow-y-auto custom-scrollbar2 flex flex-col items-start justify-start w-full h-full" data-sentry-component="DescriptionPane" data-sentry-source-file="descriptionPane.tsx">
      <ReactMarkdown components={markdownComponents} rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} data-sentry-element="ReactMarkdown" data-sentry-source-file="descriptionPane.tsx">
        {slide.slideDescription}
      </ReactMarkdown>
    </div>;
};
export default DescriptionPane;